import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const subject = `Consulta de ${formData.name} - ${formData.company}`;
    const body = `Nombre: ${formData.name}%0D%0AEmail: ${formData.email}%0D%0ATeléfono: ${formData.phone}%0D%0AEmpresa: ${formData.company}%0D%0A%0D%0AMensaje:%0D%0A${formData.message}`;
    
    window.location.href = `mailto:alex@packtosolutions.com?subject=${subject}&body=${body}`;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="py-16 sm:py-20 md:py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-black relative overflow-hidden">
      <div className="absolute top-0 right-0 w-64 sm:w-96 h-64 sm:h-96 bg-orange-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-64 sm:w-96 h-64 sm:h-96 bg-green-500/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-3 sm:mb-4">
            Hablemos de tu{' '}
            <span className="bg-gradient-to-r from-orange-500 to-green-500 bg-clip-text text-transparent">
              Proyecto
            </span>
          </h2>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-300 max-w-2xl mx-auto px-4">
            Cuéntanos tu idea y te ayudaremos a convertirla en realidad automatizada
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 sm:p-8 border border-white/10">
            <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
              <div>
                <label className="block text-white text-xs sm:text-sm font-semibold mb-2">Nombre completo</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-gray-800/50 border-2 border-gray-700 rounded-xl text-white text-sm sm:text-base focus:border-orange-500 focus:outline-none transition-colors"
                  placeholder="Tu nombre"
                />
              </div>

              <div>
                <label className="block text-white text-xs sm:text-sm font-semibold mb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-gray-800/50 border-2 border-gray-700 rounded-xl text-white text-sm sm:text-base focus:border-orange-500 focus:outline-none transition-colors"
                  placeholder="tu@email.com"
                />
              </div>

              <div>
                <label className="block text-white text-xs sm:text-sm font-semibold mb-2">Teléfono</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-gray-800/50 border-2 border-gray-700 rounded-xl text-white text-sm sm:text-base focus:border-orange-500 focus:outline-none transition-colors"
                  placeholder="+34 600 000 000"
                />
              </div>

              <div>
                <label className="block text-white text-xs sm:text-sm font-semibold mb-2">Empresa</label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  required
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-gray-800/50 border-2 border-gray-700 rounded-xl text-white text-sm sm:text-base focus:border-orange-500 focus:outline-none transition-colors"
                  placeholder="Nombre de tu empresa"
                />
              </div>

              <div>
                <label className="block text-white text-xs sm:text-sm font-semibold mb-2">Mensaje</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={4}
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-gray-800/50 border-2 border-gray-700 rounded-xl text-white text-sm sm:text-base focus:border-orange-500 focus:outline-none transition-colors resize-none"
                  placeholder="Cuéntanos sobre tu proyecto..."
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-orange-500 to-green-500 text-white text-sm sm:text-base font-bold rounded-full hover:shadow-xl hover:shadow-orange-500/30 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Enviar Consulta
              </button>
            </form>
          </div>

          <div className="space-y-6 sm:space-y-8">
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 sm:p-8 border border-white/10">
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-gradient-to-br from-orange-500 to-green-500 rounded-xl mb-4">
                <i className="ri-phone-line text-white text-xl sm:text-2xl"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-2">Teléfono</h3>
              <a href="tel:+34616308549" className="text-sm sm:text-base text-gray-300 hover:text-orange-400 transition-colors cursor-pointer">
                +34 616 308 549
              </a>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 sm:p-8 border border-white/10">
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-gradient-to-br from-orange-500 to-green-500 rounded-xl mb-4">
                <i className="ri-mail-line text-white text-xl sm:text-2xl"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-2">Email</h3>
              <a href="mailto:alex@packtosolutions.com" className="text-sm sm:text-base text-gray-300 hover:text-orange-400 transition-colors cursor-pointer break-all">
                alex@packtosolutions.com
              </a>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 sm:p-8 border border-white/10">
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-gradient-to-br from-orange-500 to-green-500 rounded-xl mb-4">
                <i className="ri-time-line text-white text-xl sm:text-2xl"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-2">Horario</h3>
              <p className="text-sm sm:text-base text-gray-300">Lunes - Viernes</p>
              <p className="text-sm sm:text-base text-gray-300">9:00 - 18:00</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}